import * as React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import { AddTemplatePanel } from '@src/framework/frame-pc/components/add-template-panel';
import { CLICK_FROM } from '../../constant';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';

@Feature()
export class InsertTemplateFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;

    public getInsertTemplateSlideDropdownContent() {
        return <AddTemplatePanel clickFrom={CLICK_FROM.TOOLBAR} />;
    }

    public shouldHide(): boolean {
        return !!this.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType;
    }
}
